export default __webpack_public_path__ + "static/media/promo_pasada_CSyMS_10Mayo.b71d3755.webp";